import React from 'react';
import { Button, Card, Dimmer } from 'tabler-react';
import fetch from '../../support/fetch';
import { status as subscriptionStatus } from '../../support/subscription';
import CardAlert from '../../Components/CardAlert';

class CancelSubscriptionCard extends React.Component {

    state = {
        showLoader: false,
        alertText: null,
        alertColor: 'danger',
    };

    changeStatus = status => {

        const ok = window.confirm('Deseja realmente continuar com esta ação?\nEsta ação é IRREVERSÍVEL.');

        if (! ok) {
            return;
        }

        this.setState({
            showLoader: true
        });

        let query;

        switch (status) {
            case 'cancel':
                query = `mutation CancelSubscriptionById ($id: ID!) {
                    cancelSubscriptionById (id: $id) {
                        id
                    }
                }`;
                break;

            default:
                break;
        }

        fetch.obj({
            query: query,
            variables: {
                id: this.props.subscription.id
            }
        })
        .then(res => {
            if (res.hasOwnProperty('errors')) {
                this.setState({
                    alertText: res.errors[0].debugMessage
                });
            }

            window.location.reload();

            this.setState({
                showLoader: false
            });
        });
    };

    cancelHandler = () => {
        this.changeStatus('cancel');
    };

    render() {

        const { subscription } = this.props;

        const content = () => {
            return (
                <React.Fragment>
                    <p>
                        Esta ação cancela PERMANENTEMENTE esta assinatura e o seu perfil, 
                        não gerando nenhuma nova cobrança em sua conta ou em seu nome.
                    </p>

                    <p className="mb-0 ">
                        Ao cancelar a sua assinatura, apesar de você 
                        ainda poder ver seu próprio perfil, todos os seus dados tornam-se 
                        invisíveis para os produtores de elenco que não terão mais acesso ao seu perfil, 
                        mesmo que você tenha sido previamente adicionado a uma pasta ou tenha sido favoritado.
                    </p>
                </React.Fragment>
            );
        };

        return (
            <Card>
                <Card.Header>
                    <h4 className="h4 m-0 text-red">CANCELAR DEFINITIVAMENTE</h4>
                </Card.Header>

                <Card.Alert color="danger" className="text-uppercase text-center">
                    <strong>Ação Definitiva</strong>
                </Card.Alert>

                <CardAlert color={this.state.alertColor}>{this.state.alertText}</CardAlert>

                <Card.Body>
                    <Dimmer loader active={!subscription} >
                        {
                            subscription &&
                            subscription.status !== subscriptionStatus.STATUS_CANCELED &&
                            content()
                        }

                        {
                            subscription &&
                            subscription.status === subscriptionStatus.STATUS_CANCELED &&
                            <div className="text-center">
                                <p>Esta assinatura está cancelada e não é possível reativá-la.</p>
                            </div>
                        }
                    </Dimmer>
                </Card.Body>

                {
                    subscription &&
                    subscription.status !== subscriptionStatus.STATUS_CANCELED &&
                    <Card.Footer className="text-center">
                        <Button
                            pill
                            color="danger"
                            outline={!this.state.showLoader}
                            loading={this.state.showLoader}
                            disabled={this.state.showLoader}
                            onClick={this.cancelHandler}>Cancelar permanentemente esta assinatura</Button>
                    </Card.Footer>
                }
            </Card>
        );
    }
}

export default CancelSubscriptionCard;